export default "__VITE_ASSET__DSLcHWV$__"